import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { myFuturiumMap } from '../../../helper';
import Headline from '../../atoms/headline/headline';
import Copy from '../../atoms/copy/copy';
import Image from '../../atoms/image/image';
import LongArrowRight from '../../icons/longArrowRight.svg';
import Container from '../../layout/container/container';
import StyledExibitionTeaser from './exhibitionTeaser.style';

const imageSizes = [
  {
    condition: 'min-width: 940px',
    width: '51vw'
  },
  {
    width: '100vw'
  }
];

const LinkWrapper = ({ uri, headline, children }) =>
  uri ? (
    <Link
      href={{
        pathname: '/universal',
        query: { uri }
      }}
      as={uri}
      className="exhibitionTeaser__link"
      title={headline}
    >
      {children}
    </Link>
  ) : (
    <div className="exhibitionTeaser__text">{children}</div>
  );

LinkWrapper.propTypes = {
  uri: PropTypes.string,
  headline: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

const ExhibitionTeaser = ({ uri, slug, subline, headline, copy, image, label }) => {
  const variant = uri && myFuturiumMap(slug, 'name');

  return (
    <StyledExibitionTeaser uri={uri} slug={slug}>
      {uri && (
        <Image
          className="exhibitionTeaser__background"
          lazy="default"
          role="presentation"
          src={`/static/dots/dots-${variant}.png`}
          srcset={[
            { src: `/static/dots/dots-${variant}-2x.png`, suffix: '2x' },
            { src: `/static/dots/dots-${variant}.png`, suffix: '1x' }
          ]}
          sizes={[
            {
              condition: 'min-width: 980px',
              width: '1440px'
            },
            {
              condition: 'min-width: 450px',
              width: '100vw'
            },
            {
              width: '100vw'
            }
          ]}
        />
      )}
      {image && (
        <div className="exhibtionTeaser__image">
          <div className="exhibtionTeaser__image-wrapper">
            <Image {...image} sizes={imageSizes} />
          </div>
        </div>
      )}
      <Container>
        <LinkWrapper uri={uri} headline={headline}>
          <div className="exhibitionTeaser__headlines">
            {subline && (
              <Headline tag="p" subline>
                {subline}
              </Headline>
            )}
            <Headline primary>{headline}</Headline>
          </div>
          <div className="exhibtionTeaser__copy">
            <Copy>{copy}</Copy>
            {uri && (
              <div className="exhibtionTeaser__label">
                <LongArrowRight
                  className="exhibitionTeaser__label-icon"
                  width="60px"
                  height="20px"
                />
                {label && (
                  <Copy thick noMargin>
                    {label}
                  </Copy>
                )}
              </div>
            )}
          </div>
        </LinkWrapper>
      </Container>
    </StyledExibitionTeaser>
  );
};

ExhibitionTeaser.propTypes = {
  uri: PropTypes.string,
  slug: PropTypes.string,
  subline: PropTypes.string,
  headline: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  image: PropTypes.shape().isRequired,
  label: PropTypes.string
};

export default ExhibitionTeaser;
